import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";
import "./InboundDashboard.css";
import API from '../../Common/api.jsx';
import DarkBackground from '../../Common/backgroundLoader';
import LoadingOverlay from 'react-loading-overlay';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

var warehouse = ''
class InboundDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      mdbTable: null,
      loading: false,
      selectedTile: null,
      tile_data: [],
      loading_icon: false,
      loading_overlay: false,
      selectedTileKey: null,
      isTileDisabled: false,     // <-- already present
      searchTerm: '',            // <-- for tracking search input
      filteredRows: []           // <-- for tracking filtered data
    };
  }

  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentWillMount() {
    warehouse = this.getCookie("selectedLocation");
    this.fetchTableDataMock(warehouse)
  }

  fetchTableDataMock = async (warehouse) => {
    this.setState({
      loading_icon: true,
      loading_overlay: true,
    })
    try {
      const response = await API.get(`/reports/get-inbound-dashboard?warehouse=${warehouse}`);
      this.setState({ data: response.data, loading_icon: false, loading_overlay: false, icon_disabled: false });

    } catch (error) {
      this.setState({
        loading_icon: false,
        loading_overlay: false,
        icon_disabled: false
      })
      console.error("Failed to fetch dashboard data:", error);
    }
  };


  fetchTilesdata = async (category, step) => {

    this.setState({
      loading: true,
      selectedTile: `${step} (${category})`,
      isTileDisabled: true      // <-- disable tiles when API starts
    });

    try {
      const { data } = await API.get(
        `/reports/get-inbound-dashboard-table?warehouse=${warehouse}&table_name=${step}&table_type=${category}`
      );

      const tileData = data.data || [];

      const columns =
        tileData.length > 0
          ? Object.keys(tileData[0]).map((k) => ({
            label: k,
            field: k,
            width: 200,
            sort: "disabled",
          }))
          : [];

      this.setState({
        tile_data: tileData,
        mdbTable: { columns, rows: tileData },
        loading: false,
        isTileDisabled: false    // <-- enable after success
      });

    } catch (err) {
      console.error(err);
      this.setState({ loading: false, isTileDisabled: false });  // <-- enable after failure
    }
  };


  handleTileClick = (category, step, value) => {

    if (this.state.isTileDisabled) return;   // <-- prevent multiple clicks

    this.setState({ tile_data: [], searchTerm: '', filteredRows: [] });

    if (!value || value === 0) {
      this.setState({ mdbTable: null, selectedTile: null, selectedTileKey: null });
      return;
    }

    this.setState({ selectedTileKey: `${category}-${step}` });

    this.fetchTilesdata(category, step);
  };

  handleDownload = () => {
    const { mdbTable, filteredRows, searchTerm } = this.state;
    
    if (!mdbTable || !mdbTable.rows || mdbTable.rows.length === 0) {
      alert('No data available to download');
      return;
    }

    // Use filtered rows if search is active, otherwise use all rows
    const rows = searchTerm ? filteredRows : mdbTable.rows;

    // Extract headers from columns
    const headers = mdbTable.columns.map(col => col.label);

    // Build CSV content
    let csvContent = headers.join(',') + '\n';
    
    rows.forEach(row => {
      const values = headers.map(header => {
        const value = row[header];
        // Handle values with commas, quotes, or newlines
        if (value === null || value === undefined) {
          return '';
        }
        const stringValue = String(value);
        if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      });
      csvContent += values.join(',') + '\n';
    });

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `${this.state.selectedTile || 'table-data'}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    const { mdbTable } = this.state;

    this.setState({ searchTerm });

    if (!mdbTable || !mdbTable.rows) return;

    // Filter rows based on search term
    if (searchTerm.trim() === '') {
      this.setState({ filteredRows: [] });
      return;
    }

    const columns = mdbTable.columns || [];
    const filteredRows = mdbTable.rows.filter(row => {
      return columns.some(col => {
        const value = String(row[col.field] || '').toLowerCase();
        return value.includes(searchTerm);
      });
    });

    this.setState({ filteredRows });
  };


  render() {
    const backend = this.state.data || {};
    const stepData = backend.data || {};
    const visual = backend.visual || {};
    const steps = Object.keys(stepData);
    const categories = Object.keys(visual);

    return (
      <div className="dashboard-wrapper">
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
            <LoadingOverlay
              active={this.state.loading_overlay}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            />
          </DarkBackground>
        )}

        <div className="tile-container">
          <div className="dashboard-container-inner">
            <div className="dashboard-header">
              <h3 className="dashboard-title">Inbound Dashboard</h3>

              <i
                className={`fa fa-refresh refresh-icon ${this.state.loading_icon ? "fa-spin disabled-icon" : ""}`}
                onClick={!this.state.loading_icon ? () => this.fetchTableDataMock(warehouse) : null}
                title={this.state.loading_icon ? "Loading..." : "Refresh Dashboard"}
              />
            </div>

            {categories.map((category) => {
              const color = visual[category] || "#888";

              return (
                <div key={category} className="tile-row">
                  {steps.map((step) => {
                    const stepInfo = stepData[step] || {};

                    if (!(category in stepInfo)) {
                      return <div key={category + "-" + step} className="tile-placeholder" />;
                    }

                    const value = stepInfo[category] || 0;
                    const tileKey = `${category}-${step}`;
                    const isSelected = this.state.selectedTileKey === tileKey;

                    const active = value > 0;

                    const bgColor = isSelected
                      ? color + "CC"
                      : active
                        ? color + "22"
                        : color + "22";

                    const borderColor = isSelected ? color + color : "#ccc";

                    return (
                      <button
                        key={tileKey}
                        disabled={this.state.isTileDisabled}   // <-- disable UI click
                        className="tile"
                        style={{
                          border: isSelected ? "5px solid " + borderColor : "1px solid #ccc",
                          borderColor: borderColor,
                          backgroundColor: bgColor,
                          transform: isSelected ? "scale(1.05)" : "scale(1)",
                          transition: "0.2s ease",
                          opacity: this.state.isTileDisabled ? 0.6 : 1
                        }}
                        onClick={() => this.handleTileClick(category, step, value)}
                      >
                        <span className="tile-value">{value}</span>
                      </button>
                    );
                  })}
                </div>
              );
            })}

            <div className="tile-row step-names">
              {steps.map((step) => (
                <div key={step} className="step-label">
                  {step}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="table-container">
          {this.state.loading ? (
            <div className="no-data">Loading data...</div>
          ) : this.state.mdbTable ? (
            <div className="table-wrapper" style={{ height: "100%", overflow: "auto" }}>

              <div className="table-title">
                <strong>{this.state.selectedTile}</strong>
                <span
                  className="pull-right"
                  onClick={() => this.handleDownload()}
                  style={{
                    fontSize: "17px",
                    paddingRight: "25px",
                    cursor: "pointer",
                    color: "#919193",
                    paddingTop: "0px",
                  }}
                >
                  <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                </span>
              </div>

              <MDBDataTable

                striped
                bordered
                scrollX
                scrollY
                small
                sortable={false}
                hover
                data={this.state.mdbTable}
                style={{ textAlign: "left", margin: "0px", padding: "0px", paddingTop: "0px" }}
              />
            </div>
          ) : (
            <div className="no-data">Click a tile to view details.</div>
          )}
        </div>

      </div>
    );
  }
}

export default InboundDashboard;
